/**
 * Image Carousel
 */
 var component_image_carousel = function(args) {

  // setup args
  var carousel = args.carousel;

  // validate
  if (!carousel) {
    console.log('Invalid image carousel');
    return;
  }

  /**
   * Init
   */
  function init_component_image_carousel() {
    const swiper_thumbs = new Swiper(carousel.querySelector('.image-carousel__thumbnails'), {
      lazy: true,
      slidesPerView: 3,
      spaceBetween: 16,
      breakpoints: {
        425: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    });
    const swiper_main = new Swiper(carousel.querySelector('.image-carousel__main-carousel'), {
      lazy: true,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper_thumbs
      }
    });
    return;
  }
  init_component_image_carousel();


  // make the call chainable
  return this;
};
